import React, { useState, useEffect, useRef } from 'react'
import { Line, Bar } from 'react-chartjs-2'
import { Chart as ChartJS } from 'chart.js/auto'
import zoomPlugin from 'chartjs-plugin-zoom'
import ChartDataLabels from 'chartjs-plugin-datalabels'
import styled from 'styled-components'

// utils
import { getTicks } from '../../../utils/getTicks'

// styles
import colors from '../../../styles/colors'

ChartJS.register(zoomPlugin)

const TEMP_DATA = [
  {
    label: '테스트1',
    borderColor: colors.mainG,
    borderWidth: 2,
    data: null,
    fill: false,
    backgroundColor: 'green',
    pointHoverRadius: 2,
    pointHoverBorderWidth: 4,
  },
]

const NewTimeChart = ({ orderSearch, isMobile, chartItem }) => {
  // test
  const chartRef = useRef(null)
  const [data, setData] = useState({
    labels: [
      '07:00',
      '08:00',
      '09:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00',
      '18:00',
      '19:00',
      '20:00',
      '21:00',
      '22:00',
      '23:00',
      '24:00',
    ],

    datasets: TEMP_DATA,

    // 플러그인
    plugins: [ChartDataLabels],
  })
  const [options, setOptions] = useState(null)

  // 툴팁 그림자
  const shadowPlugin = {
    id: 'shadow',
    beforeDraw: (chart) => {
      const { ctx } = chart
      const _fill = ctx.fill

      ctx.fill = function () {
        ctx.save()
        ctx.shadowColor = 'rgba(0, 0, 0, 0.1)'
        ctx.shadowBlur = 12
        ctx.shadowOffsetX = 0
        ctx.shadowOffsetY = 3
        _fill.apply(this, arguments)
        ctx.restore()
      }
    },
  }

  // 수직 라인
  const verticalLinePlugin = {
    id: 'verticalLiner',
    afterInit: (chart, args, opts) => {
      chart.verticalLiner = {}
    },
    afterEvent: (chart, args, options) => {
      const { inChartArea } = args
      chart.verticalLiner = { draw: inChartArea }
    },
    beforeTooltipDraw: (chart, args, options) => {
      const { draw } = chart.verticalLiner
      if (!draw) return
      const { ctx } = chart
      const { top, bottom } = chart.chartArea
      const { tooltip } = args
      const x = tooltip?.caretX
      if (!x) return
      ctx.save()
      ctx.beginPath()
      ctx.moveTo(x, top)
      ctx.lineTo(x, bottom)
      ctx.strokeStyle = colors.G2
      ctx.stroke()
      ctx.restore()
    },
  }

  useEffect(() => {
    const chart = chartRef.current

    if (chart) {
      ChartJS.register({
        id: 'verticalLiner',
        afterInit: (chart, args, opts) => {
          chart.verticalLiner = {}
        },
        afterEvent: (chart, args, options) => {
          const { inChartArea } = args
          chart.verticalLiner = { draw: inChartArea }
        },
        beforeTooltipDraw: (chart, args, options) => {
          const { draw } = chart.verticalLiner
          if (!draw) return
          const { ctx } = chart
          const { top, bottom } = chart.chartArea
          const { tooltip } = args
          const x = tooltip?.caretX
          if (!x) return
          ctx.save()
          ctx.beginPath()
          ctx.moveTo(x, top)
          ctx.lineTo(x, bottom)
          ctx.strokeStyle = colors.G2
          ctx.stroke()
          ctx.restore()
        },
      })
    }

    return () => {
      ChartJS.unregister({
        id: 'verticalLiner',
      })
    }
  }, [])

  // 날짜 포맷 변경
  useEffect(() => {
    if (isMobile) {
      setData({
        ...data,
        labels: [
          '07',
          '08',
          '09',
          '10',
          '11',
          '12',
          '13',
          '14',
          '15',
          '16',
          '17',
          '18',
          '19',
          '20',
          '21',
          '22',
          '23',
          '24',
        ],
      })
    } else {
      setData({
        ...data,
        labels: [
          '07:00',
          '08:00',
          '09:00',
          '10:00',
          '11:00',
          '12:00',
          '13:00',
          '14:00',
          '15:00',
          '16:00',
          '17:00',
          '18:00',
          '19:00',
          '20:00',
          '21:00',
          '22:00',
          '23:00',
          '24:00',
        ],
      })
    }
  }, [isMobile])

  useEffect(() => {
    if (chartItem) {
      setData({
        ...data,

        labels: chartItem.period,
        datasets: [
          {
            label: '차트뷰',
            borderColor: colors.mainG,
            borderWidth: 2,
            data: chartItem.count,
            fill: false,
            backgroundColor: 'green',
            pointHoverRadius: 2,
            pointHoverBorderWidth: 4,
          },
        ],
      })

      setOptions({
        responsive: true,

        layout: {
          padding: {
            top: 10,
          },
        },

        elements: {
          point: {
            radius: 0,
          },
        },

        scales: {
          x: {
            grid: {
              display: false,
            },

            ticks: {
              maxTicksLimit: 10,

              font: {
                size: 10,
              },
            },

            offset: true,

            title: {
              display: false,
              text: '날짜',
              font: {
                size: 12,
                weight: 'bold',
              },
            },
            border: {
              display: false,
            },
          },
          y: {
            grid: {
              display: true,
            },

            border: {
              display: false,
            },

            min: 0,
            max: getTicks(Math.max(...chartItem.count)).max,

            ticks: {
              stepSize: getTicks(Math.max(...chartItem.count)).stepSize,

              font: {
                size: 10,
              },

              // callback: function (val, index) {
              //   return Math.round(val)
              // },
            },

            beginAtZero: true,
          },
        },

        maintainAspectRatio: false,

        plugins: {
          legend: {
            display: false,
            position: 'bottom',
          },
          title: {
            display: false,
            text: '시간별 주문 지표',
          },

          zoom: {
            zoom: {
              wheel: {
                enabled: true,
              },
              mode: 'x',
              speed: 100,
            },
            pan: {
              enabled: true,
              mode: 'x',
              speed: 0.5,
            },
          },

          tooltip: {
            backgroundColor: 'white',
            padding: 16,

            titleColor: 'black',
            bodyColor: colors.mainG,
            caretSize: 0,

            titleFont: {
              size: 12,
              weight: 400,
            },
            bodyFont: {
              size: 10,
            },
            bodyAlign: 'left',
            footerFont: {},

            usePointStyle: true,

            callbacks: {
              title: function (item) {
                let filterLabel =
                  item[0].label.length < 3
                    ? `${item[0].label}:00`
                    : item[0].label

                return `${filterLabel}`
              },
              labelColor: function (item) {
                return {
                  borderColor: 'green',
                  backgroundColor: 'green',
                }
              },
              labelPointStyle: function (context) {
                return {
                  pointStyle: 'circle',
                  rotation: 0,
                }
              },
              label: function (item) {
                return ` ${item.formattedValue}건`
              },
            },
          },
        },

        hover: {
          mode: 'index',
          intersect: false,
        },

        interaction: {
          mode: 'index',
          intersect: false,
        },
      })
    }
  }, [chartItem])

  return (
    <Container>
      {data && options && (
        <Line
          data={data}
          options={options}
          ref={chartRef}
          plugins={[shadowPlugin, verticalLinePlugin]}
        />
      )}
    </Container>
  )
}

export default NewTimeChart

const Container = styled.div`
  width: 100%;
  height: 100%;
  /* min-height: 355px; */
  display: flex;

  @media ${(props) => props.theme.mobile} {
    /* min-height: 198px; */
  }
`
